import { Box, Stack, Typography, keyframes } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';

const pulse = keyframes`
  0%, 80%, 100% { opacity: 0.3; transform: scale(0.85); }
  40% { opacity: 1; transform: scale(1); }
`;

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const AgentThinkingCard = () => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 1.5 }}>
      <Stack direction="row" spacing={0.875} alignItems="center" sx={{ py: 0.75 }}>
        <Stack direction="row" spacing={0.625} alignItems="center">
          {[0, 1, 2].map(i => (
            <Box
              key={i}
              sx={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                bgcolor: theme.palette.primary.main,
                animation: `${pulse} 1.4s ease-in-out infinite`,
                animationDelay: `${i * 0.2}s`,
              }}
            />
          ))}
        </Stack>
        <Typography
          sx={{
            fontSize: '0.8125rem',
            fontStyle: 'italic',
            color: alpha(theme.palette.text.primary, 0.7),
            background: `linear-gradient(90deg, ${alpha(theme.palette.text.primary, 0.4)} 0%, ${theme.palette.text.primary} 50%, ${alpha(theme.palette.text.primary, 0.4)} 100%)`,
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: `${shimmer} 2s linear infinite`,
          }}
        >
          analyzing your request…
        </Typography>
      </Stack>
    </Box>
  );
};

export default AgentThinkingCard;
